'use strict';

import $ from 'jquery';
import { flashMessage } from '@/js/application/admin';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '#admin-update-email-form', (e) => {
    e.preventDefault();

    const $form = $(e.target);
    const email = $form.find('input[name="email"]').val();
    const url = $form.attr('action');

    $.post(url, { email })
      .done((e) => {
        $(`[data-admin-user-row][data-id=${e.data.id}]`).replaceWith(e.data.html);
        flashMessage(e.notice);
        $.modal.close();
      })
      .fail((e) => {
        $form.find('input[type=submit]').prop('disabled', false).val('Update');
        $form.find('input:first').focus();
        flashMessage(e.responseJSON.alert, 'alert');
      });

    return false;
  });

  $(document).on('click', '.p-button--change-to-admin', (e) => {
    e.preventDefault();
    const url = $(e.target).attr('href');
    $.post(url).done((users) => {
      $(`[data-admin-user-row][data-id=${users.data.user_id}]`).replaceWith(users.data.user_html);
      $(`[data-admin-user-row][data-id=${users.data.prev_admin_id}]`).replaceWith(
        users.data.prev_admin_html
      );
      flashMessage(users.notice);
      $.modal.close();
    });

    return false;
  });

  $(document).on('submit', '#admin-update-password-form', (e) => {
    e.preventDefault();

    const $form = $(e.target);
    const password = $form.find('input[name="password"]').val();
    const url = $form.attr('action');

    $.post(url, { password })
      .done((e) => {
        $(`[data-admin-user-row][data-id=${e.data.id}]`).replaceWith(e.data.html);
        flashMessage(e.notice);
        $.modal.close();
      })
      .fail((e) => {
        $form.find('input[type=submit]').prop('disabled', false).val('Update');
        $form.find('input:first').focus();
        flashMessage(e.responseJSON.alert, 'alert');
      });

    return false;
  });

  $(document).on($.modal.OPEN, '.modal--transfer-projects', () => {
    $('#transfer-projects-form').find('.p-button').prop('disabled', true);

    const selectizedProjects = $('#selectized-transfer-projects').selectize({
      plugins: ['remove_button'],
      persist: false,
      render: {
        item(data, escape) {
          return `<div class="field__tag-item">${escape(data.text)}</div>`;
        },
      },
    });

    $('#selectized-transfer-projects').on('change', (e) => {
      if ($(e.target).val().length > 0 && $(e.target).val().includes('all_projects')) {
        const selectize = selectizedProjects[0].selectize;
        selectize.setValue(Object.keys(selectize.options).filter((v) => parseInt(v) > 0));
        selectize.$control_input.blur();
      }
    });

    $('#transfer-projects-form').on('keyup paste change', (e) => {
      if (
        ($('#selectized-transfer-projects').val().length ||
          $('#transfer_everything_yes').prop('checked')) &&
        $('#transfer_to').val() &&
        $('#email_send_to').val()
      ) {
        $('#transfer-projects-form').find('.p-button').prop('disabled', false);
      } else {
        $('#transfer-projects-form').find('.p-button').prop('disabled', true);
      }
    });

    $('.transfer-everything-radio').on('change', (e) => {
      if ($(e.target).val() === 'yes') {
        selectizedProjects[0].selectize.disable();
      } else {
        selectizedProjects[0].selectize.enable();
      }
    });

    $('#transfer-projects-form').on('submit', (e) => {
      e.preventDefault();
      $(e.target).find('.form-error').hide();
      $.post($(e.target).attr('action'), $(e.target).serialize()).done((res) => {
        if (res.error) {
          $(e.target)
            .find('.form-error')
            .html(`Can not transfer projects, due to:<br> ${res.message}`)
            .show();
          $(e.target).find('.p-button').val('Initiate Transfer').prop('disabled', false);
        } else {
          $(e.target)
            .find('.form-error')
            .html('Transfering projects is being processed. Email will be sent after that.')
            .show();
        }
      });
    });
  });

  $(document).on($.modal.CLOSE, '.modal--transfer-projects', (e) => {
    $(e.target).remove();
  });

  $(document).on($.modal.OPEN, '.modal--duplicate-account', () => {
    $('#duplicate-account-form').on('submit', (e) => {
      e.preventDefault();
      $(e.target).find('.form-error').hide();
      $.post($(e.target).attr('action'), $(e.target).serialize()).done((res) => {
        if (res.error) {
          $(e.target)
            .find('.form-error')
            .html(`Can not duplicate account, due to:<br> ${res.message}`)
            .show();
          $(e.target).find('.p-button').val('Initiate Duplication').prop('disabled', false);
        } else {
          $(e.target)
            .find('.form-error')
            .html('Account duplication is being processed. Email will be sent after that.')
            .show();
        }
      });
    });
  });

  $(document).on($.modal.CLOSE, '.modal--duplicate-account', (e) => {
    $(e.target).remove();
  });

  $(document).on($.modal.OPEN, '.modal--delete-team', () => {
    $('#delete-team-form').on('submit', (e) => {
      e.preventDefault();
      const fullyDestroy = $(e.target).find('.p-button').val() !== 'Yes, let remove!';
      $(e.target).find('.form-error').hide();
      $.post($(e.target).attr('action'), fullyDestroy ? { full_destroy: true } : {}).done((res) => {
        if (res.error) {
          $(e.target).find('.form-error').html(res.message).show();
          $(e.target)
            .find('.p-button')
            .val('I read above notification, let fully destroy the team anyway!')
            .prop('disabled', false);
        } else {
          $(e.target)
            .find('.form-error')
            .html('Successfully destroyed the team. Please reload the page!')
            .show();
        }
      });
    });
  });

  $(document).on($.modal.CLOSE, '.modal--delete-team', (e) => {
    $(e.target).remove();
  });
});
